// @ts-nocheck
import gsap from 'gsap'
import { defPath, fetchPath } from '../config/defPath'
import { triggerCustomEvent } from './eventController'

// import CryptoJS from 'crypto-js'
import aes from 'crypto-js/aes'
import encHex from 'crypto-js/enc-hex'
import padZeroPadding from 'crypto-js/pad-zeropadding'
import { useSession, useVideoPopup } from '../hooks/useState'
import useLocalStorage from '../hooks/useLocalData'
import { useGeneralConfig } from "../hooks/useGeneralConfig"

window.dataLayer = window.dataLayer || [];

// let userLogged = false
// const userLogged = useSession.getState().logged

// const validateSession = async () => {
//   const res = await fetch(`${fetchPath}/aguila/loyalty/validate/session`, {
//     method: "POST"
//   })
//   const user = useSession.getState().logged
//   console.log('popsController - endpoint session: ', res)
//   if (res.ok) userLogged = true
//   return res.ok
// }

export class PopsController {
  public modalWrapper: HTMLElement | null
  public popupContent: HTMLElement | null
  public popup: HTMLElement | null
  public timeline

  constructor() {
    this.modalWrapper = document.querySelector('.ar__popup_overlay')
    this.popup = document.querySelector(".ar__popup")
    this.popupContent = document.querySelector(".ar__popup--content")
    this.timeline = gsap.timeline({
      defaults: {
        ease: 'power1.in',
        duration: 0.35
      }
    })
  }

  async open(id: string, data?: string | any) {
    if (!id || !this.popupContent) return

    window.avatar && window.avatar.toggleControls(false)
    
    switch (id) {
      case "initialGender":
        this.popupContent.innerHTML = await renderTemplateGender()
        configGender()
        break;
      case "alert":
        this.popupContent.innerHTML = await renderTemplateAlert()
        configAlert()
        break;
      case "predicciones":
        this.popupContent.innerHTML = await renderTemplatePredicciones()
        configPredicciones()
        break;
      case "regalo":
        this.popupContent.innerHTML = await renderTemplateRegalo()
        configRegalo()
        break;
      case "tada":
        this.popupContent.innerHTML = renderTemplateTadaCode(data)
        configTada()
        break;
      case "tada-not-user":
        this.popupContent.innerHTML = renderTemplateTadaCodeNotUser(data)
        break;
      case "collectable":
        const url = '/aguila/loyalty/get-collectable'
        let res: any = await fetch(url, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: data
        })

        let dataRes = await res.json()

        window.dataLayer.push({
          'event': 'GAEvent',
          'event_category': 'Content',
          'event_action': 'Content',
          'event_label': `${data} - Collectables`,
          'interaction': 'true',
          'component_name': 'Modo_Carrera_Stadium_CollectablesandPP',
          'element_text': `${dataRes.coins} monedas, ${dataRes.points} puntos`,
        });
        
        this.popupContent.innerHTML = await renderTemplateCollectable(dataRes)

        configCollectable(dataRes, data)
        break;
      case "questions":
        this.popupContent.innerHTML = await renderSuccessQuestions(data)
        window.dataLayer.push({
          'event': 'GAEvent',
          'event_category': 'Content',
          'event_action': 'Content',
          'event_label': 'You answered correctly - PassionPoint',
          'interaction': 'true',
          'component_name': 'Modo_Carrera_Stadium_CollectablesandPP',
          'element_text': 'Felicidades, contestaste correctamente',
        });
        configTemplateQuestions(data)
        break;
      case "redeem":
        this.popupContent.innerHTML = await renderRedeem(data)
        configRedeem(data)
        break;
      case "redirect":
        this.popupContent.innerHTML = await renderRedirectPopup(data)
        configRedirectPopup(data)
        break;
      default:
        break;
    }

    //

    this.timeline.to(this.modalWrapper, {
      opacity: 1,
      onStart() {
        this.targets()[0].style.display = 'block'
      }
    }, 0)

    this.timeline.to(this.popup, {
      y: '0%',
      opacity: 1
    }, 0.25)
  }

  close() {

    window.avatar && window.avatar.toggleControls(true)

    return new Promise(resolve => {

      this.timeline.to(this.popup, {
        y: '20%',
        opacity: 0
      }, 0)
      this.timeline.to(this.modalWrapper, {
        opacity: 0,
        onComplete() {
          this.targets()[0].style.display = 'none'
          window.popRedirect = false
          resolve('Done!')
        }
      }, 0.25)

    })

  }
}

const renderTemplateGender = async (): Promise<string> => {
  return new Promise(resolve => {
    resolve(`
      <h3 class="ar__popup--title subtitleSmall">Selecciona <br />tu avatar</h3>
      <div class="boxIcon">
        <button class="ar__btn-primary icon-man" data-gender="Hombre">
          <img class="avatar" src="${defPath}/assets/images/popups/iconMen1.png" alt="man" />
        </button>
        <button class="ar__btn-primary icon-woman" data-gender="Mujer">
          <img class="avatar" src="${defPath}/assets/images/popups/iconWoman1.png" alt="woman" />
        </button>
      </div>
    `)
  })
}
const renderTemplateAlert = async (): Promise<string> => {
  return `
    <img class="ar__popup--icon" src="${defPath}/assets/images/popups/premios.png" alt="icono premios" />
    <h3 class="ar__popup--title subtitleSmall premio">
      <span class="title_2">Gánate un <br/> meet & greet </span><br />
      con la selección
    </h3>
    <p class="medium_30 premio">Regístrate para competir por éste y todos los premios que hemos preparado para ti</p>
    <button class="ar__btn-primary">
      Ver premios
    </button>
  `
}
const renderTemplatePredicciones = async (): Promise<string> => {
  return `
    <h3 class="ar__popup--title subtitleSmall">
      Ya casi estÁs <br/> en la titular</span>
    </h3>
    <p class="medium_30">Para poder guardar tus predicciones y <br/> participar por premios, es necesario que <br/> tengas una cuenta e inicies sesión</p>
    <a class="ar__btn-primary" href="/estadio-aguila/registro?redirect=${location.pathname}">Registrarme</a>
    <span class="medium_30">
      ¿ya tienes cuenta?
      <a class="yellow" href='/estadio-aguila/iniciar-sesion?redirect=${location.pathname}'>Inicia Sesión</a>  
    </span>
  `
}
const renderTemplateTadaCodeNotUser = (data) => {
  window.dataLayer.push({
    'event': 'GAEvent',
    'event_category': 'Content',
    'event_action': 'Content',
    'event_label': 'you found a code',
    'interaction': 'true',
    'component_name': 'Modo_Carrera_Codes',
    'element_text': '¡FELICITACIONES! Has encontrado un código lleno de puntos y monedas',
  });

  return `
  <div class="ar__popup__tada">
    <h3 class="ar__popup__tada--title">¡Felicitaciones!</h3>
    <p class="medium_30">'Has activado una trivia'</p>
    
    <p class="ar__popup__tada--description no-user" >'Regístrate para participar ahora'</p>

    <a class="ar__btn-primary" href="/estadio-aguila/registro">Registrarme</a>

    <span class="ar__popup__tada--link">
      ¿ya tienes cuenta?
      <a class="yellow" href='/estadio-aguila/iniciar-sesion'>Inicia Sesión</a>  
    </span>
  </div>
  `
}
const renderTemplateTadaCode = (data) => {

  if (data.code !== 1) {
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Content',
      'event_label': `You won ${data.points} points and ${data.coins} coins - `,
      'interaction': 'true',
      'component_name': 'Modo_Carrera_Codes',
      'element_text': 'Acumulaste puntos y sumaste más monedas',
    });
  }

  return `
  <div class="ar__popup__tada" style="${data.code === 1 ? 'gap: 28px' : ''}">
    <h3 class="ar__popup__tada--title">${ data.code === 1 ? "EL CÓDIGO YA HA SIDO REDIMIDO" : "¡Felicitaciones!" }</h3>
    <p class="medium_30">${ data.code === 1 ? "El código que ingresaste ya ha sido redimido. Por favor, ingresa uno nuevo." : "Has encontrado un código lleno de <br/> puntos y monedas" }</p>
  
    <div class="ar__popup__tada__awards" style="${data.code === 1 ? 'display: none' : ''}">
      <div class="ar__popup__tada__coins">
        <span>+${data.coins}</span>
        <img class="ar__popup__coins--icon" src="${defPath}/assets/images/icons/coins.png" alt="icono premios" />
      </div>
      <div class="ar__popup__tada__points">
        <span>+${data.points}</span>
        <span class="ar__pts">pts</span>
      </div>
    </div>

    <button class="ar__btn-primary btn-large">Aceptar</button>
  </div>
  `
}
const renderTemplateRegalo = async () => {
  const data = useGeneralConfig.getState().code
  // const url = '/aguila/loyalty/get-general-config';
  // const res = await fetch(url)
  // const data = await res.json()
  // const data = {code: "{codigo}"}
  if (data.code !== null) {
    return `
      <div class="ar__popup__gift">
        <h3 class="ar__popup__gift--title">¡quÉ crack!</h3>

        <div class="medium_30">
          ${data.description.value}
        </div>

        <div class="ar__popup__gift--code whiteShadow">
          <span  data-code="${data.code}">${data.code}</span>
          <input type="text" id="codeCopy" value="${data.code}" defaultValue="${data.code}" style="display: none" />
        </div>

        <p class="medium_30">Ve a TaDa y reclama tu descuento.</p>

        <div class="ar__popup__gift--row">
          <button class="ar__popup__gift--btn">copiar código</button>

          <a href='https://www.tadadelivery.com.co/aguila?_q=aguila&map=ft' target='_blank' class="ar__btn-tada">
            <span>Ir a</span>
            <img src="${defPath}/assets/images/icons/logo_tada.svg" alt="logo tada" />
          </a>
        </div>
      </div>
    `
  }

}

const renderTemplateCollectable = async (data: string | undefined): Promise<string> => {
  // const user = await validateSession()
  const user = useSession.getState().logged
  return `
      <h3 class="ar__popup--title subtitleSmall">¡Felicidades!</h3>
      <p class="medium_30 titleCollectable">Has encontrado uno de los 50 coleccionables únicos y has obtenido: </p>
      <div class="ar__popup__awards">
        <div class="ar__popup__points">+${data.points}<span class="ar__pts">pts</span></div>
        <div class="ar__popup__coins">
          <span>+${data.coins}</span>
          <img class="ar__popup__points--icon" src="${defPath}/assets/images/icons/coins.png" alt="icono premios" />
        </div>
      </div>
      <p class="medium_30" style="display: ${user ? "none" : "block"}">${user ? "" : "Regístrate para reclamar tu recompensa"}</p>
      <button class="ar__btn-primary">${user ? "aceptar" : "Registrarme"}</button>
    `
}

const renderSuccessQuestions = async (data: string | undefined): Promise<string> => {
  // const user = await validateSession()
  const user = useSession.getState().logged
  return `
    <h3 class="ar__popup--title subtitle_black">¡Crack!</h3>
    <p class="medium_30" style="max-width: 75%;">Mostraste tus conocimientos de fútbol y obtuviste:</p>
    <div class="ar__popup__awards">
    <div class="ar__popup__points">+${data.points}<span class="ar__pts">pts</span></div>
      <div class="ar__popup__coins">
        <span>+${data.coins}</span>
        <img class="ar__popup__points--icon" src="${defPath}/assets/images/icons/coins.png" alt="icono premios" />
      </div>
    </div>
    <p class="medium_30">${user ? "" : "Regístrate para reclamar tu recompensa"}</p>
    <button class="ar__btn-primary">${user ? "aceptar" : "¡Quiero registrarme!"}</button>
  `
}

const renderRedeem = async (data: string | undefined): Promise<string> => {
  return `
    <div class="ar__popup--redeemed">
      <figure class="ar__popup--redeemed-image">
        <img src="${defPath}/assets/images/thumbnail/${data.article}" alt="icono premios" />
      </figure>
      <div class="ar__popup__points">
        <img class="ar__popup__points--icon" src="${defPath}/assets/images/popups/points.png" alt="icono premios" />
        <span class="ar__title">${data.points}</span>
      </div>
    </div>
    <h3 class="ar__popup--title subtitleSmall">Confirmar</br> Compra</h3>
    <p class="medium_30 wc">¿Estás seguro de que deseas comprar este artículo?</p>
    <button class="ar__btn-primary">¡Lo quiero!</button>
  `
}

const renderRedirectPopup = async (data: string) => {
  const popup = useGeneralConfig.getState().popups
  
  if (popup && popup.length > 0) {
    const popupActive = popup.filter((item) => item.key === data)
    if (popupActive.length > 0) {
      const popupUrl = popupActive[0].url
      const popupCopy = popupActive[0].copy.value

      window.dataLayer.push({
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': 'Content',
        'event_label': data,
        'interaction': 'true',
        'component_name': 'Modo_Carrera_Stadium_CollectablesandPP',
        'element_text': popupCopy.replace( /(<([^>]+)>)/ig, ''),
      });
      
      return `
        <div class="ar__popup--content--redirect mb-30">
          <h3 class="ar__popup--title subtitleSmall mb-30">${popupCopy}</h3>
          <button class="ar__btn-primary btn-large" data-link="${popupUrl}">Ir</button>
          <button class="ar__btn-secondary btn-large">Cancelar</button>
        </div>
      `
    } else {
      return `
        <div class="ar__popup--content--redirect mb-30">
          <h3 class="ar__popup--title subtitleSmall mb-30">¡Ups! <br/> Algo salió mal</h3>
          <button class="ar__btn-secondary btn-large">Aceptar</button>
        </div>
      `
    }
  }
}

declare global {
  interface Window {
    avatar: any
    cameraController: any
    collectables: any
  }
}

const configGender = () => {
  const btnClose = document.querySelector('.ar__popup--close') as HTMLButtonElement
  const btnCloseMobile = document.querySelector('.ar__popup_overlay .ar__popup--close') as HTMLButtonElement
  const header = document.querySelector('.newHeaderAL') as HTMLElement
  if (btnClose) {
    btnClose.style.opacity = '0'
    btnCloseMobile.style.opacity = '0'
  }
  // if(header){
  //   header.style.setProperty('opacity', '0', 'important')
  // }

  document.querySelectorAll('.ar__popup .boxIcon .ar__btn-primary').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      window.soundController.play('clic', false, 1)
      await new PopsController().close()

      const gender = btn.getAttribute('data-gender')
      window.avatar.initModel({ gender, destiny: 'Estadio' })
      window.cameraController.target = window.avatar.target
      window.cameraController.panning('Estadio', 6)

      sessionStorage.setItem('tempGender', gender)
      sessionStorage.setItem('btnStartClicked', 'true')

      window.dataLayer.push({
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': 'Button',
        'event_label': `${gender === 'Hombre' ? 'Masculino' : 'Femenino'} - Gender`,
        'interaction': 'true',
        'component_name': 'Modo_Carrera_Gender',
        'element_text': 'Selección de Género',
      });

      // setTimeout(() => {
      //   new PopsController().open('alert')
      // }, 5000);
      //header.style.setProperty('opacity', '1', 'important')
      gsap.to(header, {
        opacity: "1",
        duration: .3,
        autoAlpha: 1
      })
      btnClose.style.opacity = '1'

      setTimeout(() => {
        useVideoPopup.setState({ isOpen: true })
      }, 6000);
    })
  })

}

const configAlert = () => {
  const title = document.querySelector('.ar__popup--title.subtitleSmall')?.textContent
  const btn = document.querySelector('.ar__popup .ar__btn-primary') as HTMLButtonElement
  const btnCloseMobile = document.querySelector('.ar__popup_overlay .ar__popup--close') as HTMLButtonElement

  btnCloseMobile.style.opacity = '1'
  window.dataLayer.push({
    'event': 'GAEvent',
    'event_category': 'Content',
    'event_action': 'Content',
    'event_label': 'See Prizes',
    'interaction': 'true',
    'component_name': 'Modo_Carrera_Popup_prizes',
    'element_text': title,
  });

  const close = () => {
    new PopsController().close()
    triggerCustomEvent("renderAlert", {
      title: `Aun no tenemos premios...`,
      desc: `Intenta de nuevo mas tarde`,
      type: `info`,
    })
  }

  btn && btn.addEventListener('click', (e: any) => {
    // close()    
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': 'See Prizes',
      'interaction': 'true',
      'component_name': 'Modo_Carrera_Popup_prizes',
      'element_text': e.target.textContent,
    });
    location.href = '/estadio-aguila/premios'
  })

  btnCloseMobile && btnCloseMobile.addEventListener('click', (e: any) => {
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': 'Close PopUp Prizes',
      'interaction': 'true',
      'component_name': 'Modo_Carrera_Popup_prizes',
      'element_text': 'Cerrar',
    });
  })

}

const configCollectable = (pointsC: any, idCol: string) => {
  const container = document.querySelector('.ar__popup') as HTMLElement
  const btn = document.querySelector('.ar__popup .ar__btn-primary') as HTMLButtonElement
  const closeBtn = document.querySelector('.ar__popup--close') as HTMLButtonElement
  let clicked = false

  container?.classList.add('collectable')

  btn && btn.addEventListener('click', async () => {
    handleSendCoins(btn, clicked, pointsC)
    container?.classList.remove('collectable')

    let updateData = {
      ...useSession.getState().user,
      collectables: pointsC.new
    }
    useSession.setState({ 
      user : updateData
    })
  })

  closeBtn && closeBtn.addEventListener('click', async () => {
    handleSendCoins(btn, clicked, pointsC)
    container?.classList.remove('collectable')
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': `${idCol} - Collectables`,
      'interaction': 'true',
      'component_name': 'Modo_Carrera_Stadium_CollectablesandPP',
      'element_text': `Cerrar`,
    });
  })

  async function handleSendCoins(btn, clicked, pointsC) {
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': `${btn.innerText} - Collectables`,
      'interaction': 'true',
      'component_name': 'Modo_Carrera_Stadium_CollectablesandPP',
      'element_text': `${btn.innerText}`,
    });
    if (clicked) return
    clicked = true

    if (useSession.getState().logged) {
      // session true -> obtener -> fetch -> true ? alertGREEN : alertRED
      btn.classList.add('ar__btn-loading')
      const statusQuestion = await saveCollectable(idCol)

      if (statusQuestion) {
        setTimeout(() => {

          triggerCustomEvent("renderAlert", {
            title: `Sumaste ${pointsC.coins} monedas y ${pointsC.points}pts.`,
            desc: `Explora y reclama más recompensas`,
            type: `great`
          })
        }, 1000);
      } else {
        setTimeout(() => {
          triggerCustomEvent("renderAlert", {
            title: `Algo ha salido mal...`,
            desc: `Intenta de nuevo`,
            type: `error`
          })
        }, 1000);
      }

      new PopsController().close()
      window.collectables.removeCollectable()

    } else {
      new PopsController().close()
      sessionStorage.setItem('paola', idCol)
      window.location.href = "/estadio-aguila/registro"

    }
  }
}

const configTemplateQuestions = (body: any) => {
  const container = document.querySelector('.ar__popup') as HTMLElement
  const btn = document.querySelector('.ar__popup .ar__btn-primary') as HTMLButtonElement
  const closeBtn = document.querySelector('.ar__popup--close') as HTMLButtonElement
  let clicked = false
  container?.classList.add('collectable')

  btn && btn.addEventListener('click', async () => {
    handleSendCoins(btn, clicked, body)
  })
  
  closeBtn && closeBtn.addEventListener('click', async () => {
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': 'Register Questions',
      'interaction': 'true',
      'component_name': 'PopUp Questions',
      'element_text': `Close Popup`,
    });
    new PopsController().close()
    container?.classList.remove('collectable')
  })

  async function handleSendCoins(btn, clicked, body) {
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': 'Register Questions',
      'interaction': 'true',
      'component_name': 'PopUp Questions',
      'element_text': `${btn.innerText}`,
    });

    if (useSession.getState().logged) {
      // validar solo primer click
      if (clicked) return
      clicked = true

      // session true -> obtener -> fetch -> true ? alertGREEN : alertRED
      btn.classList.add('ar__btn-loading')

      const { coins, points, ...bodyNew } = body
      const statusQuestion = await sendQuestion(bodyNew)

      if (statusQuestion) {
        setTimeout(() => {
          triggerCustomEvent<AlertProps>("renderAlert", {
            title: `Sumaste ${coins} monedas y ${points} pts`,
            desc: `Explora y reclama más recompensas`,
            type: `great`,
            time: 5000
          })
        }, 1000);
      } else {
        setTimeout(() => {

          triggerCustomEvent("renderAlert", {
            title: `Algo ha salido mal...`,
            desc: `Intenta de nuevo`,
            type: `error`,
            time: 5000
          })
        }, 1000);
      }

      new PopsController().close()

    } else {
      new PopsController().close()
      sessionStorage.setItem('daniela', JSON.stringify(body))
      window.location.href = "/estadio-aguila/registro"
    }
  }
}

const configRedeem = ({ points, article }: { points: any, article: string }) => {
  const btn = document.querySelector('.ar__popup .ar__btn-primary') as HTMLButtonElement
  const btnClose = document.querySelector('.ar__popup--close') as HTMLButtonElement

  window.redeem = article
  if (btnClose) {
    btnClose.classList.add('canjeables')
    btnClose.addEventListener('click', () => {
      btnClose.classList.remove('canjeables')
    })
  }

  btn?.addEventListener('click', async () => {
    // DATALAYERS
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': `${article} - Redeem Coins`,
      'interaction': 'true',
      'component_name': 'Modo_Carrera_CoinRedemption',
      'element_text': 'Comprar',
    });
    const { status, message } = await updateCoins(encrypt(points), encrypt(article.replace('.png', '')))

    if (status) {
      triggerCustomEvent("renderAlert", {
        title: `Felicitaciones`,
        desc: `${message}`,
        type: `great`,
        time: 5000
      })

      triggerCustomEvent('saveAvatar', {
        item: article
      })
    } else {
      setTimeout(() => {

        triggerCustomEvent("renderAlert", {
          title: `Algo ha salido mal...`,
          desc: `${message}`,
          type: `error`,
          time: 5000
        })
      }, 1000);
    }
    // const user = await validateSession()

    useSession.getState().validateSession()

    new PopsController().close()
  })
}

export const sendQuestion = async (body: any) => {
  // guardar pregunta y respuesta
  try {
    const saveQuestion = await fetch(`${fetchPath}/aguila/loyalty/save/question`, {
      method: 'POST',
      body: JSON.stringify(body)
    })
    const data = await saveQuestion.json()
    if (data.coins) {
      useSession.setState({ coins: parseInt(data.coins) })
      useSession.setState({ points: parseInt(data.points) })
    }
    return saveQuestion.ok

  } catch (error) {
    // console.log('Error:', error.message);sendQuestion
    return false
  }
}

export const saveCollectable = async (idCol: string) => {
  try {
    // guardar monedas
    const res = await fetch(`${fetchPath}/aguila/loyalty/save-collectable`, {
      method: 'POST',
      body: JSON.stringify({ collectable_id: useSession.getState().user.collectables })
    })
    const data = await res.json()

    // triggerCustomEvent("updateCoins", { points: parseInt(data.response) })
    if (data.coins) {

      let updateData = {
        ...useSession.getState().user,
        collectables: data.collectables
      }
      useSession.setState({
        points: parseInt(data.points),
        coins: parseInt(data.coins),
        user : updateData
      })

    }
    return res.ok

  } catch (error) {
    // console.log('error: ', error.message);
    return false
  }
}

export const updateCoins = async (points: string, article: string) => {
  try {
    // guardar monedas
    const res = await fetch(`${fetchPath}/aguila/loyalty/change/coins`, {
      method: 'POST',
      body: JSON.stringify({ coins: points, article })
    })

    const data = await res.json()

    if (data.response) {
      triggerCustomEvent("updateCoins", { points: parseInt(data.response) })
    }

    return { status: res.ok, message: data.message }

  } catch (error) {
    // console.log('error: ', error.message);
    return { status: false, message: data.message }
  }
}


export const encrypt = (msg: any) => {

  // the key and iv should be 32 hex digits each, any hex digits you want, but it needs to be 32 on length each
  let key = encHex.parse("462D4A614E645267556B587032733576");
  let iv = encHex.parse("34753778217A25432A462D4A614E6452");
  // let key = encHex.parse("0123456789abcdef0123456789abcdef");
  // let iv =  encHex.parse("abcdef9876543210abcdef9876543210");

  // encrypt the message
  let encrypted = aes.encrypt(msg, key, { iv: iv, padding: padZeroPadding }).toString();

  return encrypted
}




// const listUrl = {
//   camerino: '/estadio-aguila/camerino',
//   tada: '/estadio-aguila/codigo-tada',
//   predicciones: '/estadio-aguila/predicciones',
//   noticias: '/estadio-aguila/noticias',
//   futbolin: '/estadio-aguila/instrucciones',
//   retos: '/estadio-aguila/reto-semanal',
// }
const configRedirectPopup = (data:string) => {

  const btnRedirect = document.querySelector('.ar__popup_overlay .ar__btn-primary') as HTMLButtonElement
  btnRedirect && btnRedirect.addEventListener('click', () => {
    // listUrl[data] && location.assign(listUrl[data])
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': `${data}`,
      'interaction': 'true',
      'component_name': 'Modo_Carrera_Stadium_CollectablesandPP',
      'element_text': `${btnRedirect.innerHTML}`,
    });
    btnRedirect.dataset.link && location.assign(btnRedirect.dataset.link)
  })

  const btnCancel = document.querySelector('.ar__popup_overlay .ar__btn-secondary') as HTMLButtonElement
  btnCancel && btnCancel.addEventListener('click', () => {
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': `${data}`,
      'interaction': 'true',
      'component_name': 'Modo_Carrera_Stadium_CollectablesandPP',
      'element_text': `${btnRedirect.innerHTML}`,
    });
    new PopsController().close()
  })

}

const configPredicciones = () => {

  const btnClose = document.querySelector('.ar__popup_overlay .ar__popup--close')

  btnClose && btnClose.addEventListener('click', () => {
    new PopsController().close()
    const storedItems = JSON.parse(localStorage.getItem('loyalty') || '{}');
    delete storedItems["predicciones"];
    localStorage.setItem('loyalty', JSON.stringify(storedItems));
  })

  window.dataLayer.push({
    'event': 'GAEvent',
    'event_category': 'Content',
    'event_action': 'Content',
    'event_label': 'See Popup Save Predicciones',
    'interaction': 'true',
    'component_name': 'Modo_Carrera_Popup_Predicciones',
    'element_text': 'Ya casi estÁs en la titular',
  });

}
const configRegalo = () => {
  const btnCopy = document.querySelector('.ar__popup__gift--btn')
  const closeBtn = document.querySelector('.ar__popup--close.logged')
  closeBtn && closeBtn.classList.remove('logged')

  btnCopy && btnCopy.addEventListener('click', () => {
    const code = document.querySelector('#codeCopy')
    // const codeText = code?.getAttribute('data-code')
    const codeText = navigator.clipboard.writeText(code.value);
    window.openAlert({
      title: `Codigo ${code.value}`,
      desc: `Copiado al portapapeles`,
      type: `great`,
      time: 3000
    })
    setTimeout(3000)
  //   if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
  //     navigator.clipboard.writeText(codeText).then(() => {
  //       window.openAlert({
  //         title: `Codigo ${codeText}`,
  //         desc: `Copiado al portapapeles`,
  //         type: `great`,
  //         time: 3000
  //       })
  //     })
  //   }
  })

  window.dataLayer.push({
    'event': 'GAEvent',
    'event_category': 'Content',
    'event_action': 'Content',
    'event_label': `See popup gifts`,
    'interaction': 'true',
    'component_name': 'Modo_Carrera_Popup_gifts',
    'element_text': 'Has encontrado uno de los 200 códigos premiados con un descuento en TaDa ',
  });

}
const configTada = () => {
  const btnClose = document.querySelector('.ar__popup_overlay .ar__btn-primary.btn-large')

  btnClose && btnClose.addEventListener('click', () => {
    new PopsController().close()
  })
}

// window.popup = PopsController
